export default "__VITE_ASSET__DbbPEdb4__"